import styled from "styled-components";
import TextareaAutosize from "react-textarea-autosize";

export const Input = styled(TextareaAutosize)`
  padding: 10px;
  max-width: 100%;
  border: 1px solid hsl(0, 0%, 70%);
  border-radius: 5px;
  &:focus {
    box-shadow: 0 0 10px rgb(3 169 244 / 20%);
    border: 1px solid #1e22ff;
  }
`;
